import { Event as GQLItem } from '../../../generated/api.graphql';
import { take } from '../../../util';
import * as Venue from '../Venue/Venue';
import * as EventAnnounceSummary from './EventAnnounceSummary';

export type Event = {
  id: number;
  name: string;
  slug: string;
  startTime?: string;
  endTime?: string;
  doorTime?: string;
  description?: string;
  ticketsUrl?: string;
  timezone?: string;
  /**
   * Typed as the whole `Venue` because `VenueSummary` carries only id/name, but populated from
   * whatever the caller selected. The order-detail query asks for id, name, locale, currency,
   * timezone and address — the fields a printed ticket needs — so the rest is `undefined`, and
   * `rooms` comes back `[]` (an artifact of `Venue.fromGql`, not "this venue has no rooms").
   */
  venue?: Venue.Venue;
  announceDetail?: EventAnnounceSummary.EventAnnounceSummary;
};

export const fromGql = (item: GQLItem): Event => ({
  ...take<Event>(item, 'id', 'name', 'slug', 'startTime', 'endTime', 'doorTime', 'description', 'ticketsUrl', 'timezone'),
  venue: item.venue ? Venue.fromGql(item.venue) : undefined,
  announceDetail: item.announceDetail ? EventAnnounceSummary.fromGql(item.announceDetail) : undefined,
});
